import styled from 'styled-components';
import { IFrameDefault } from './interface';

const defaultComponent = styled.div<IFrameDefault>`
  display: ${(props) => {
    if (props.isActive) {
      if (props.display === 'grid') {
        return props.display;
      }
      return 'flex';
    }
    return 'none';
  }};
  grid-template-areas: ${(props) =>
    props.gridTemplateAreas ? props.gridTemplateAreas : 'none'};
  grid-template-columns: ${(props) =>
    props.gridTemplateColumns ? props.gridTemplateColumns : 'none'};
  grid-template-rows: ${(props) =>
    props.gridTemplateRows ? props.gridTemplateRows : 'none'};
  grid-area: ${(props) => (props.gridArea ? props.gridArea : 'none')};
  row-gap: ${(props) => (props.rowGap ? props.rowGap : 'none')};
  column-gap: ${(props) => (props.columnGap ? props.columnGap : 'none')};
  grid-auto-flow: ${(props) =>
    props.gridAutoFlow ? props.gridAutoFlow : 'none'};
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : 'column'};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : 'center'};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};
  width: ${(props) => (props.width ? props.width : 'auto')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  margin: ${(props) => (props.margin ? props.margin : '0.5rem')};
  padding: ${(props) => (props.padding ? props.padding : 0)};
  color: ${(props) => (props.color ? props.color : props.theme.colors.text)};
  border: none;
  border-radius: ${(props) => props.theme.border.default};
  box-shadow: ${(props) => props.theme.shadow.default};
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : props.theme.colors.white};
`;

const Frame = {
  Default: defaultComponent,
};

export default Frame;
